const SIM_OFFERS_PLANS_OPTIONS = {
    ALL: { name: 'Tous', value: 'ALL' },
    DATA_ONLY: { name: 'Data Only', value: 'Data Only' },
    WITHOUT_DATA_ONLY: { name: 'Sans Data Only', value: 'WITHOUT_DATA_ONLY' }
};

export default SIM_OFFERS_PLANS_OPTIONS;